import script from "./update_password.vue?vue&type=script&setup=true&lang=js"
export * from "./update_password.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__